








import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class LoadBar extends Vue {
  @Prop({default: 1}) public load!: number;
  private coordinates: { [percent: number]: [number, number] } = {
    0: [0.8, 0],
    5: [15, 1.1],
    10: [29, 1.1],
    15: [43.2, 1.1],
    20: [57.2, 1.1],
    25: [71.6, 1.1],
    30: [85.8, 1.1],
    35: [99.9, 1.1],
    40: [0.7, 50.8],
    45: [15, 50.8],
    50: [29, 50.8],
    55: [43.2, 50.8],
    60: [57.4, 50.8],
    65: [71.6, 50.8],
    70: [85.8, 50.8],
    75: [99.9, 50.8],
    80: [0.7, 99.1],
    85: [15, 99.1],
    90: [29, 99.1],
    95: [43.2, 99.1],
    100: [57.4, 99.1]
  };

  get barStyles() {
    const coords = this.coordinates[Math.ceil(this.load / 5) * 5];
    if (!coords) {
      console.log(`Skipping unknown load ${this.load}`);
      return {};
    }

    return {
      backgroundPosition: `${coords[0]}% ${coords[1]}%`
    };
  }
}
